import { dateNow } from './dateNow';

export const getEndTime = (until: number): number => dateNow() + until * 1000;
